import { render } from "./MySettings.vue?vue&type=template&id=6be5f8a8&scoped=true"
import script from "./MySettings.vue?vue&type=script&lang=js"
export * from "./MySettings.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./MySettings.vue?vue&type=style&index=1&id=6be5f8a8&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be5f8a8"]])

export default __exports__